<div class="input-tabs" #tabsContainer>
  <div class="input-tabs__container axs-container">
    <div class="axs-container-inner-wrapper">
      <div class="axs-lg-offset-left-1">
        <div class="input-tabs__layout">
          <!-- Left Side: Input Tabs -->
          <div class="input-tabs__left-wrapper">
            <div class="input-tabs__left-stack">
              <div class="input-tabs__left-header">
                <ng-content select="[slot='left-header']"></ng-content>
              </div>

              <div class="input-tabs__left">
                <!-- Tab Headers -->
                <div class="input-tabs__headers">
                  <button
                    *ngFor="let tab of tabs; let i = index"
                    type="button"
                    class="input-tabs__tab"
                    [class.input-tabs__tab--active]="i === currentTabIndex"
                    (click)="goToTab(i)">
                    <span class="input-tabs__tab-icon-wrapper">
                      <img
                        *ngIf="tab.activeIcon"
                        class="input-tabs__tab-icon input-tabs__tab-icon--active"
                        [class.input-tabs__tab-icon--visible]="i === currentTabIndex"
                        [src]="tab.activeIcon"
                        alt=""
                        aria-hidden="true"
                      />
                      <img
                        *ngIf="tab.icon"
                        class="input-tabs__tab-icon input-tabs__tab-icon--inactive"
                        [class.input-tabs__tab-icon--visible]="i !== currentTabIndex"
                        [src]="tab.icon"
                        alt=""
                        aria-hidden="true"
                      />
                    </span>
                    <span class="input-tabs__tab-text">{{ tab.title }}</span>
                  </button>
                </div>

                <input-tabs-coachmark class="input-tabs__coachmark" flagName="inputTabsCoachMark"></input-tabs-coachmark>

                <!-- Tab Content -->
                <div class="input-tabs__content">
                  <ng-content></ng-content>
                </div>
              </div>
            </div>

            <!-- Navigation Arrows -->
            <div class="input-tabs__navigation">
              <div [class.disabled]="isFirstTab" (click)="!isFirstTab && previousTab()">
                <ngx-axs-button
                  [axsType]="'icon-only'"
                  [axsIconType]="'arrowLeft'"
                  axsSize="small">
                </ngx-axs-button>
              </div>

              <div class="input-tabs__indicators">
                <span
                  *ngFor="let tab of tabs; let i = index"
                  class="input-tabs__indicator"
                  [class.input-tabs__indicator--active]="i === currentTabIndex">
                </span>
              </div>

              <div [class.disabled]="isLastTab" (click)="!isLastTab && nextTab()">
                <ngx-axs-button
                  [axsType]="'icon-only'"
                  [axsIconType]="'arrowRight'"
                  axsSize="small">
                </ngx-axs-button>
              </div>
            </div>
          </div>

          <!-- Right Side: Charts/Visualization Area -->
          <div class="input-tabs__right">
            <ng-content select="[slot='charts']"></ng-content>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
